import React, { useEffect, useMemo, useRef, useState } from 'react';
import './Menu.css';

const menuData = {
  
  Combo: [
    { name: "Get it Combo", description: "FRIES AND SOFT DRINK WITH ANY PIZZA, SAJ, BURGER, OR SUB", price: 2.5 }
  ],


  Appetizers: [
    { name: "Fries", description: "", price: 3, image: "/Charleyspics/appetizers/fries.png" },
    { name: "Wedges", description: "", price: 4, image: "/Charleyspics/appetizers/wedges.jpg" },
    { name: "Curly", description: "", price: 6, image: "/Charleyspics/appetizers/curly fries.jpg" },
    { name: "Mozzarella Sticks (5pcs)", description: "", price: 6, image: "/Charleyspics/appetizers/mozzarella sticks.jpg" },
    { name: "Chicken Strips (4pcs)", description: "", price: 6, image: "/Charleyspics/appetizers/chicken strips.jpg" },
    { name: "Wings BBQ or Buffalo (8pcs)", description: "", price: 6, image: "/Charleyspics/appetizers/wings.jpg" },
    { name: "Nuggets (8pcs)", description: "", price: 6, image: "/Charleyspics/appetizers/nuggets.jpg" },
    { name: "Garlic Bread", description: "Served with mayo & cheese", price: 5, image: "/Charleyspics/appetizers/garlic bread.jpg" },
    { name: "Baked Potatoes", description: "", price: 3, image: "/Charleyspics/appetizers/baked potatoes.jpg" },
    { name: "Onion Rings", description: "", price: 6, image: "/Charleyspics/appetizers/onion rings.jpg" },
    { name: "Calamari (7pcs)", description: "Served with Tartare sauce", price: 8, image: "/Charleyspics/appetizers/calamari.jpg" },
    { name: "Charley’s Special Nachos", description: "Tortilla with melted cheese, mixed with vegetables. Served with cheddar sauce", price: 9, image: "/Charleyspics/appetizers/nachos.jpg" },
    { name: "Charley’s Mixed Platter", description: "2 pcs garlic bread, 2 mozzarella, 2 shrimps, 2 calamaris, 2 wings, 2 fingers, wedge potatos", price: 15, image: "/Charleyspics/appetizers/mixed platter.jpg" }
  ],

   Salads: [
    { name: "Season Salad", description: "lettuce, tomatoes, cucumbers, green pepper, corn, olives", price: 6, image: "/Charleyspics/salad/salad season.jpg" },
    { name: "Chef Salad", description: "Ham, cheese, lettuce, tomatoes, cucumbers, olives, corn", price: 7, image: "/Charleyspics/salad/salad chef.jpg" },
    { name: "Greek Salad", description: "Feta cheese, lettuce, tomatoes, olives, corn", price: 6, image: "/Charleyspics/salad/salad greek.jpg" },
    { name: "Caesar Salad", description: "Lettuce, parmesan, croutons, caesar sauce", price: " 6, (+2.5 with chicken)", image: "/Charleyspics/salad/caesar.png" },
    { name: "Crab Salad", description: "Crab sticks, lettuce, tomatoes, cucumbers, carrots, olives, corn, and green peppers", price: 8, image: "/Charleyspics/salad/salad crab.jpg" },
    { name: "Pasta Salad", description: "Tricolors pasta, tuna, tomatoes, cucumbers, carrots, olives, and corn mixed with our special lemon mayo dressing", price: 10, image: "/Charleyspics/salad/salad pasta.jpg" },
    { name: "Charley’s Super Salad", description: "Steak and chicken strips, lettuce, tomatoes, cucumbers, carrots, olives, corn, and green peppers", price: 10, image: "/Charleyspics/salad/salad super.jpg" }
  ],


  Burgers: [
    { name: "Classic Burger", description: "Beef patty, mayo, ketchup, mustard, pickles, onion, tomatoes, lettuce", price: 6, image: "/Charleyspics/burgers/burger classic.jpg" },
    { name: "Cheese Burger", description: "Beef patty, cheddar cheese, mayo, ketchup, mustard, pickles, onion, tomatoes, lettuce", price: 6.5, image: "/Charleyspics/burgers/cheeseburger.png" },
    { name: "Chicken Burger", description: "Grilled chicken breast, mayo, lettuce, tomatoes, pickles", price: 5.5, image: "/Charleyspics/burgers/burger chicken.jpg" },
    { name: "Double Cheese Burger (Signature)", description: "2 beef patties, cheese, mayo, ketchup, mustard, pickles, onion, tomatoes, lettuce", price: 9, image: "/Charleyspics/burgers/burger double cheese.jpg" },
    { name: "Lebanese Burger", description: "Beef patty, coleslaw, cheese, ketchup, fries", price: 6, image: "/Charleyspics/burgers/burger lebanese.jpg" },
    { name: "BBQ Bacon Burger", description: "Beef patty, bbq, mayo, honey mustard, bacon, cheddar cheese, pickles, lettuce", price: 6.5, image: "/Charleyspics/burgers/burger bbq bacon.jpg" },
    { name: "Fish Burger", description: "Breaded fish fillet, tartar sauce, lettuce, pickles", price: 6, image: "/Charleyspics/burgers/burger fish.jpg" },
    { name: "Mozzarella Burger", description: "Mozzarella patty, cocktail sauce, lettuce, tomatoes, pickles", price: 5.5, image: "/Charleyspics/burgers/burger mozzarella.jpg" }
  ],

  Pizza: [
    { name: "Margherita", description: "Pizza sauce, cheese", price: { S: 5.5, M: 10, L: 12 }, image: "/Charleyspics/pizza/pizza margherita.jpg" },
    { name: "Pepperoni", description: "Pizza sauce, pepperoni, cheese", price: { S: 6, M: 12, L: 16 }, image: "/Charleyspics/pizza/pizza pepperoni.jpg" },
    { name: "Lebanese", description: "Pizza sauce, ham, mushrooms, cheese, black olives", price: { S: 6.5, M: 12, L: 16 }, image: "/Charleyspics/pizza/pizza lebanese.jpg" },
    { name: "Meat Lovers (Butchery Boy)", description: "Pizza sauce, pepperoni, sausages, meatballs, ham, cheese", price: { S: 6.5, M: 12, L: 16 }, image: "/Charleyspics/pizza/pizza meat lovers.jpg" },
    { name: "Chicken BBQ", description: "Grilled Chicken topped with BBQ sauce", price: { S: 6.5, M: 12, L: 16 }, image: "/Charleyspics/pizza/pizza chicken bbq.jpg" },
    { name: "Chicken Deluxe", description: "Pizza sauce, chicken, fresh garlic, cheese, broccoli", price: { S: 6.5, M: 12, L: 16 }, image: "/Charleyspics/pizza/pizza chicken deluxe.jpg" },
    { name: "4 Cheese", description: "Pizza sauce, mixed cheese", price: { S: 6.5, M: 12, L: 16 }, image: "/Charleyspics/pizza/pizza four cheese.jpg" },
    { name: "Vegetarian", description: "Pizza sauce, Feta cheese, broccoli, tomatoes, fresh mushrooms, onions, green pepper, black olives, corn", price: { S: 6.5, M: 13, L: 17 }, image: "/Charleyspics/pizza/pizza veggie.jpg" },
    { name: "Supreme (Signature)", description: "Pizza sauce, pepperoni sausages, meatballs, ham ,mushrooms, green pepper, onions, corn, cheese", price: { S: 8.5, M: 15, L: 19 }, image: "/Charleyspics/pizza/pizza supreme.jpg" },
    { name: "Shrimp Pizza", description: "Deep fried shrimps", price: { S: 7.5, M: 13, L: 17 }, image: "/Charleyspics/pizza/pizza shrimp.jpg" },
    { name: "Hawaiian Pizza", description: "Ham and pineapples", price: { S: 7.5, M: 13, L: 17 }, image: "/Charleyspics/pizza/pizza hawaiien.jpg" }
  ],

   Subs: [
    { name: "Marinated Chicken", description: "Marinated grilled chicken, mayo, lettuce, pickles, tomatoes, melted cheese", price: 6.5, image: "/Charleyspics/sub/sub marinated chicken.jpg" },
    { name: "Philadelphia", description: "Steak strips, mushrooms, green pepper, onions, mayo, lettuce, melted cheese", price: 7.5, image: "/Charleyspics/sub/sub philly.jpg" },
    { name: "Fajita Chicken", description: "Marinated chicken, green pepper, onions, special red sauce, tomatoes, melted cheese", price: 6.5, image: "/Charleyspics/sub/sub fahita.jpg" },
    { name: "American Sub", description: "Ham, cheese, mayo, lettuce, tomatoes, pickles", price: 6.5, image: "/Charleyspics/sub/sub american.jpg" },
    { name: "Boneless Crispy", description: "Chicken strips, mayo, pickles, tomatoes, lettuce, cheese", price: 6.5, image: "/Charleyspics/sub/sub boneless.jpg" },
    { name: "Chicken Cutlet Parmesan Sub", description: "Breaded chicken, marinara sauce, green pepper, fries, with melted cheese", price: 7.5, image: "/Charleyspics/sub/sub chicken cutlet parmesan.jpg" },
    { name: "Crab Sub", description: "Crab sticks, mayo, lettuce, tomatoes, sliced lemons.", price: 7.5, image: "/Charleyspics/sub/sub crab.jpg" },
    { name: "Tuna Sub", description: "Tuna, mayo, lettuce, tomatoes, sliced lemons", price: 7.5, image: "/Charleyspics/sub/sub tuna.jpg" }
  ],

   Calzone: [
    { name: "Crispy Chicken", description: "Stuffed with pizza sauce, chicken, mozzarella & cheddar cheese", price: 10, image: "/Charleyspics/calezone/calezone crispy chicken.jpg" },
    { name: "Steak and Cheese", description: "Stuffed with steak, mozzarella cheese, fresh mushroom, onions, green pepper", price: 12, image: "/Charleyspics/calezone/calezone steak and cheese.jpg" },
    { name: "Chicken Deluxe", description: "Grilled chicken, broccolli, garlic", price: 10, image: "/Charleyspics/calezone/calezone chicken deluxe.jpg" },
    { name: "Ham and Cheese", description: "Ham, mozzarella & cheddar cheese with fresh mushrooms", price: 9, image: "/Charleyspics/calezone/calezone ham and cheese.jpg" }
  ],

  "Charley’s Specialties": [
    { name: "Saj Taouk", description: "Taouk, mayo, garlic, coleslaw, pickles, ketchup, fries", price: 5.5, image: "/Charleyspics/saj/saj tawouk.jpg" },
    { name: "Saj Taouk Special", description: "Taouk, mayo, garlic, coleslaw, pickles, ketchup, fries, cheese", price: 6, image: "/Charleyspics/saj/saj tawouk special.jpg" },
    { name: "Saj Taouk Royal", description: "Taouk, curry sauce, coleslaw, pickles, cheese, fries", price: 6.5, image: "/Charleyspics/saj/saj tawouk royale.jpg" },
    { name: "Saj Shawarma Beef", description: "Meat strips, tarator, parsley, tomatoes, pickles", price: 7.5, image: "/Charleyspics/saj/saj shawarma beef.jpg" },
    { name: "Saj Shawarma Chicken", description: "Chicken strips, garlic, lettuce, pickles, fries", price: 6.5, image: "/Charleyspics/saj/saj shawarma chicken.jpg" },
    { name: "Saj Steak and Cheese", description: "Meat strips, fresh mushrooms, onion, green pepper, lettuce, tomatoes, mayo, cheddar", price: 7.5, image: "/Charleyspics/saj/saj steak and cheese.jpg" },
    { name: "Saj Crispy Chicken", description: "Chicken tenders, lettuce, tomatoes, mayo, pickles, cheese", price: 6.5, image: "/Charleyspics/saj/saj crispy.png" },
    { name: "Saj Fajita Chicken", description: "Chicken, green pepper, onions, tomatoes, special red sauce, cheese", price: 6.5, image: "/Charleyspics/saj/saj fahita.jpg" },
    { name: "Saj Soujouk", description: "Soujouk, mayo, pickles, onions, tomatoes, lettuce, cheese", price: 6.5, image: "/Charleyspics/saj/saj soujouk.jpg" },
    { name: "Saj Ham and Cheese", description: "Ham, cheese, mayo, lettuce, tomatoes, pickles", price: 6, image: "/Charleyspics/saj/saj ham and cheese.jpg" },
    { name: "Saj Chocoba", description: "Nutella, banana", price: 5.5, image: "/Charleyspics/dessert/saj chocoba.jpg" }
  ],

  "Arabic Sandwiches XXL": [
    { name: "Taouk", description: "Grilled chicken, coleslaw, ketchup, garlic, pickles, fries", price: 5},
    { name: "Shawarma chicken", description: "Chicken, Garlic, lettuce, pickles, fries", price: 5, },
    { name: "Shawarma beef", description: "Beef, Pickles, Tomatoes, Parsley, Sumac, Onions, Tarator", price: 6.67,},
    { name: "Kafta", description: "Kafta, Hommos, Pickles, Tomatoes, Parsley, Sumac, Onions, Tarator", price: 5,},
    { name: "Kabab", description: "Kabab, Hommos, Pickles, Tomatoes, Parsley, Sumac, Onions, Tarator", price: 5,},
    { name: "Djej", description: "Chicken breast strips, Garlic, Pickles, Lettuce, Fries", price: 5,},
    { name: "Makanek", description: "Makanek Sausages, Mayo, Onions, Pickles, Lettuce, Fries, Debes remmen", price: 5,},
    { name: "Soujouk", description: "Soujouk, Mayo, lettuce, Pickles, Tomatoes, Onions", price: 5,},
  ],

   "Farouj (Mansourieh Only)": [
    { name: "Farouj Fahem", description: "Farouj, garlic sauce, hommos, fries, pickles", price: 15, image: "/Charleyspics/Farouj/fullfarouj.jpg"},
    { name: "Half Farouj Fahem", description: "Half Farouj, garlic sauce, hommos, fries, pickles", price: 9, image: "/Charleyspics/Farouj/halffarouj.jpg" },
    { name: "Farouj Family Pack", description: "Farouj, Fatoush, Rice, garlic sauce, hommos, fries, pickles", price: 20, image: "/Charleyspics/Farouj/faroujfamily.png" },
  ],

 

  Platters: [
    { name: "Taouk Platter", description: "Taouk, french fries, pickles, coleslaw, bread, with garlic dip", price: 10, image: "/Charleyspics/platters/platter tawouk.jpg" },
    { name: "Marinated Chicken Platter", description: "Marinated chicken, grilled tomatoes, onion, pepper, french fries, bread, coleslaw", price: 11, image: "/Charleyspics/platters/platter marinated chicken.jpg" },
    { name: "Cheese Burger Platter", description: "Beef patty, mayo, ketchup, mustard, lettuce, tomatoes, french fries, coleslaw", price: 10, image: "/Charleyspics/platters/platter chicken burger.jpg" },
    { name: "Chicken Burger Platter", description: "Grilled chicken breast, mayo, lettuce, tomatoes, pickles, french fries, coleslaw", price: 10, image: "/Charleyspics/platters/platter chicken burger.jpg" },
    { name: "Shawarma Chicken Platter", description: "Marinated chicken strips, mayo garlic, french fries, pickles", price: 11, image: "/Charleyspics/platters/platter shawarma chicken.jpg" },
    { name: "Shawarma Beef Platter", description: "Marinated beef strips, tarator, french fries", price: 12, image: "/Charleyspics/platters/platter shawarma beef.jpg" },
    { name: "Crispy Chicken Tenders (5pcs)", description: "Fried chicken tenders, french fries, coleslwaw or garden salad", price: 10, image: "/Charleyspics/platters/platter crispy chicken.jpg" },
    { name: "Chicken Wings Platter (10pcs)", description: "BBQ or Buffalo wings, french fries, coleslaw", price: 10, image: "/Charleyspics/platters/platter wings.jpg" },
    { name: "Chicken Cutlet Parmesan", description: "Breaded chicken, marinara sauce, melted cheese, with bread. Served with french fries and your choice of coleslaw or garden salad", price: 13, image: "/Charleyspics/platters/platter chicken cutlet.jpg" },
    { name: "Fish and Chips", description: "Deep fried fish fillet with tartare sauce, with bread. Served with french fries and your choice of coleslaw or garden salad", price: 10, image: "/Charleyspics/platters/platter fish and chips.jpg" },
    { name: "Cape Code", description: "Baked fish fillet, with bread. Served with french fries and your choice of coleslaw or garden salad", price: 12, image: "/Charleyspics/platters/platter cape code.jpg" },
    { name: "Seafood Platter", description: "Deep fried shrimps, calamari, fish fillet, with bread. Served with french fries and your choice of coleslaw or garden salad", price: 16, image: "/Charleyspics/platters/platter sea food.jpg" },
    { name: "Chicken Leonardo Pasta", description: "Penne, leonardo sauce, chicken. Served with two garlic bread with cheese topped with parmesan.", price: 15, image: "/Charleyspics/platters/platter chicken leonardo.jpg" }
  ],

  Drinks: [
    { name: "Soft Drink", description: "", price: 1.5 },
    { name: "Ice Tea", description: "", price: 2 },
    { name: "Sparkling Water", description: "", price: 1.5 },
    { name: "Juice", description: "", price: 1.5 },
    { name: "Mineral Water", description: "", price: 0.5 }
  ],

};
const Menu = ({ isOverlayOpen = false }) => {
  const categories = useMemo(() => Object.keys(menuData), []);
  const [selectedItem, setSelectedItem] = useState(null);
  const [activeCategory, setActiveCategory] = useState(categories[0]);
  const sectionRefs = useRef({});
  const navRefs = useRef({});

  const centerActiveButton = (category, smooth = true) => {
    const activeButton = navRefs.current[category];
    if (!activeButton) return;

    const container = activeButton.parentElement;
    if (!container) return;

    const buttonLeft = activeButton.offsetLeft;
    const buttonWidth = activeButton.offsetWidth;
    const containerWidth = container.offsetWidth;

    container.scrollTo({
      left: buttonLeft - containerWidth / 2 + buttonWidth / 2,
      behavior: smooth ? 'smooth' : 'auto',
    });
  };

  const scrollToCategory = (category) => {
    const section = sectionRefs.current[category];
    if (!section) return;

    setActiveCategory(category);
    centerActiveButton(category);

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  useEffect(() => {
    if (isOverlayOpen) return;

    const getActiveCategory = () => {
      const triggerLine = window.innerWidth <= 768 ? 110 : 140;
      const bottomThreshold = window.innerWidth <= 768 ? 220 : 260;

      let current = '';
      let closestCategory = categories[0];
      let closestDistance = Infinity;

      categories.forEach((category) => {
        const section = sectionRefs.current[category];
        if (!section) return;

        const rect = section.getBoundingClientRect();
        const distance = Math.abs(rect.top - triggerLine);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestCategory = category;
        }

        if (rect.top <= triggerLine && rect.bottom >= triggerLine) {
          current = category;
        }
      });

      const scrollBottom = window.scrollY + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const nearBottom = pageHeight - scrollBottom <= bottomThreshold;

      if (nearBottom) {
        const comboSection = sectionRefs.current.Combo;
        const drinksSection = sectionRefs.current.Drinks;

        if (comboSection) {
          const comboRect = comboSection.getBoundingClientRect();
          if (comboRect.top <= window.innerHeight - 40) {
            return 'Combo';
          }
        }

        if (drinksSection) {
          const drinksRect = drinksSection.getBoundingClientRect();
          if (drinksRect.top <= window.innerHeight - 40) {
            return 'Drinks';
          }
        }
      }

      return current || closestCategory;
    };

    const handleScroll = () => {
      const nextActive = getActiveCategory();

      setActiveCategory((prev) => {
        if (prev !== nextActive) {
          centerActiveButton(nextActive);
          return nextActive;
        }
        return prev;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [categories, isOverlayOpen]);

  useEffect(() => {
    centerActiveButton(activeCategory, false);
  }, [activeCategory]);

  const closeModal = () => {
    setSelectedItem(null);
  };

  const renderPrice = (price) => {
    if (typeof price === 'object' && price !== null) {
      return Object.entries(price)
        .filter(([, value]) => value !== 0 && value !== '0')
        .map(([size, value]) => `${size}: $${value}`)
        .join(' / ');
    }

    return `$${price}`;
  };

  return (
    <div className="app__menu">
      <div className="app__menu-header">
        <h1 className="headtext__cormorant">Our Menu</h1>
        <div className="header-underline"></div>
      </div>

      {!isOverlayOpen && (
  <div className="menu-category-navbar">
    <div className="menu-category-navbar-scroll">
      {categories.map((category) => (
        <button
          key={category}
          ref={(el) => {
            navRefs.current[category] = el;
          }}
          className={`menu-category-nav-btn ${
            activeCategory === category ? 'active' : ''
          }`}
          onClick={() => scrollToCategory(category)}
        >
          {category}
        </button>
      ))}
    </div>
  </div>
)}

      <div className="app__menu-sections">
        {Object.entries(menuData).map(([category, items]) => (
          <section
            key={category}
            ref={(el) => {
              sectionRefs.current[category] = el;
            }}
            className="menu-category-section"
          >
            <h2 className="menu__title">{category}</h2>

            <div className="app__menu-item-cards">
              {items.map((item, index) => (
                <div
                  key={index}
                  className="menu-item-wrapper"
                  onClick={() => setSelectedItem(item)}
                >
                  <div className="menu-item-card">
                    {item.image && (
                      <img
                        src={item.image}
                        alt={item.name}
                        className="item-image"
                      />
                    )}

                    <div className="item-content">
                      <h3 className="item-name">{item.name}</h3>

                      {item.description && (
                        <p className="item-description">{item.description}</p>
                      )}

                      <p className="item-price">{renderPrice(item.price)}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>

      {selectedItem && (
        <div className="modal" onClick={closeModal}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedItem.image && (
              <img
                src={selectedItem.image}
                alt={selectedItem.name}
                className="modal-image"
              />
            )}

            <h3 className="modal-title">{selectedItem.name}</h3>

            {selectedItem.description && (
              <p className="modal-description">{selectedItem.description}</p>
            )}

            <p className="modal-price">{renderPrice(selectedItem.price)}</p>

            <button className="modal-close" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Menu;